import { Component, OnInit, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from "@angular/material";
import { UserService } from "../../Services/user.service";

@Component({
  selector: "app-delete-account-dialog",
  templateUrl: "./delete-account-dialog.component.html",
  styleUrls: ["./delete-account-dialog.component.scss"]
})
export class DeleteAccountDialog implements OnInit {
  constructor(public dialogRef: MatDialogRef<DeleteAccountDialog>, @Inject(MAT_DIALOG_DATA) public data: any, public userService: UserService) { }

  ngOnInit() {}
  closeAction() {
    this.dialogRef.close();
  }

  async deleteAccount() {
    const response = await this.userService.deleteAccount();
    this.userService.logout();
  }
}
